import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { QExpansionItem } from "quasar"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { confirmationDialog } from "src/util/functions/dialogs"
import { showInfoNotification } from "src/util/functions/notifications"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxIssueBase',
  props: {
  title: {
    type: String,
    required: true,
  },

  required: {
    type: Boolean,
    default: false,
  },

  disable: {
    type: Boolean,
    default: false,
  },

  promptDiscard: {
    type: Boolean,
    default: false,
  },

  infoNotification: {
    type: Boolean,
    default: false,
  },
},
  emits: ["show", "hide"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

__expose({ forceHide, forceShow })

//endregion

//region Variables

const { t } = useI18n()

const menuStatus = ref(false)
const expansionItem = ref<QExpansionItem | undefined>()
const forcefullyClosed = ref(false)

const classes = computed(() => {
  return {
    "sfx-issue-base-bordered": menuStatus.value,
    "sfx-issue-base-required": props.required,
  }
})

const disabledClass = computed(() => {
  return {
    "sfx-issue-base-disable": props.disable,
  }
})

const expandIcon = computed(() => (menuStatus.value ? Icons.SQUARE_MINUS : Icons.SQUARE_PLUS))

//endregion

//region Functions

function showMenu() {
  menuStatus.value = true
  emit("show")
}

async function hideMenu() {
  if (!props.promptDiscard || forcefullyClosed.value) {
    emit("hide")
    forcefullyClosed.value = false
    return
  }

  const userConfirmed = await confirmationDialog({
    title: t("sfxIssues.dialog_title"),
    content: t("sfxIssues.dialog_content"),
    persistent: true,
  })
  if (userConfirmed) {
    menuStatus.value = false
    emit("hide")
  } else {
    menuStatus.value = true
  }

  forcefullyClosed.value = false
}

function forceHide() {
  forcefullyClosed.value = true
  expansionItem.value?.hide()
}

function handleDisableClick() {
  if (props.disable && props.infoNotification)
    showInfoNotification(t("sfxIssues.disabled_icon_info_message"))
}

function forceShow() {
  showMenu()
  expansionItem.value?.show()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    flat: "",
    class: _normalizeClass([classes.value, "sfx-issue-base q-px-md"]),
    onClick: handleDisableClick
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(QExpansionItem), {
        class: _normalizeClass(disabledClass.value),
        ref_key: "expansionItem",
        ref: expansionItem,
        modelValue: menuStatus.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menuStatus).value = $event)),
        "expand-icon": expandIcon.value,
        "header-class": "q-pa-none",
        "expand-icon-class": "text-primary",
        "expand-icon-toggle": "",
        onShow: showMenu,
        onHide: hideMenu
      }, {
        header: _withCtx(({ expanded }) => [
          _createVNode(_component_q_item_section, {
            class: _normalizeClass(expanded ? 'text-subtitle1' : 'text-overline')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.title), 1)
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_q_separator, {
              class: "q-mr-none q-ml-none q-mb-lg",
              inset: ""
            }),
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["class", "modelValue", "expand-icon"])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})